import React from 'react';
import Navbar from '../components/Navbar';
import { trackToolAction } from '../utils/metrics';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import moment from 'moment-timezone';
import { set } from 'date-fns';

function DVRTime() {

	const [buttonActive, setButtonActive] = React.useState(false);
	const [currentTime, setCurrentTime] = React.useState(dayjs().format('MM/DD/YYYY HH:mm'));

	setInterval(function() {
		setCurrentTime(dayjs().format('MM/DD/YYYY HH:mm:ss'));
	}, 1000);

	const [incidentTime, setIncidentTime] = React.useState();
	const incidentTimeChanged = function(e) { setIncidentTime(e); }

	const [dvrTime, setDvrTime] = React.useState();
	const dvrTimeChanged = function(e) { setDvrTime(e); setButtonActive(true); }

	const [timeDiffString, setTimeDiffString] = React.useState();
	const [dvrTimeConverted, setDvrTimeConverted] = React.useState();

	const convertTime = function() {
    trackToolAction('/dvrtime', 'DVR Time Converter');
		if (incidentTime) console.log("Incident time", incidentTime.format('MM/DD/YYYY HH:mm:ss'));
		if (dvrTime) console.log("DVR Time", dvrTime.format('MM/DD/YYYY HH:mm:ss'));

		var diff = dvrTime.diff(dayjs(), 'minute');
		var incidentTimeOnDvr = incidentTime.add(diff, 'minute').format('MM/DD/YYYY HH:mm A');
		if (mode === "unknownIncidentTime") {
			incidentTimeOnDvr = incidentTime.subtract(diff, 'minute').format('MM/DD/YYYY HH:mm:ss');
		}

		var displayedDifference = "";
		var tempDiff = 0;
		if (diff > 60) {
			var hours = Math.floor(diff / 60);
			var minutes = diff % 60;
			if (hours >= 24) {
				var days = Math.floor(hours / 24);
				hours = hours % 24;
				displayedDifference = days + " days, " + hours + " hours, and " + minutes + " minutes";
			} else {
				displayedDifference = hours + " hours and " + minutes + " minutes";
			}
		} else if (diff < -60) {
			tempDiff = diff * -1;
			var hours = Math.floor(tempDiff / 60);
			var minutes = tempDiff % 60;
			if (hours >= 24) {
				var days = Math.floor(hours / 24);
				hours = hours % 24;
				displayedDifference = days + " days, " + hours + " hours, and " + minutes + " minutes";
			} else {
				displayedDifference = hours + " hours and " + minutes + " minutes";
			}
		} else {
			displayedDifference = diff + " minutes";
		}

		if (mode === 'knownIncidentTime') {
			if (diff > 0) {
				setTimeDiffString("DVR is ahead of current time by " + displayedDifference + ".");
				setDvrTimeConverted("Incident time on DVR is " + incidentTimeOnDvr);
			} else if (diff < 0) {
				setTimeDiffString("DVR is behind current time by " + displayedDifference + ".");
				setDvrTimeConverted("Incident time on DVR is " + incidentTimeOnDvr);
			} else {
				setTimeDiffString("DVR is synced with current time. Incident time on DVR is " + incidentTimeOnDvr + "");
				setDvrTimeConverted("Incident time on DVR is " + incidentTimeOnDvr);
			}
		} else if (mode === 'unknownIncidentTime') {
			if (diff > 0) {
				setTimeDiffString("DVR is ahead of current time by " + displayedDifference + ".");
				setDvrTimeConverted("Real time of incident is " + incidentTimeOnDvr);
			} else if (diff < 0) {
				setTimeDiffString("DVR is behind current time by " + displayedDifference + ".");
				setDvrTimeConverted("Real time of incident is " + incidentTimeOnDvr);
			} else {
				setTimeDiffString("DVR is synced with current time.");
				setDvrTimeConverted("Real time of incident is " + incidentTimeOnDvr);
			}
		}
	}

	const [alignment, setAlignment] = React.useState('left');
	const [mode, setMode] = React.useState('knownIncidentTime');
	const [incedentTimePickerLabel, setIncidentTimePickerLabel] = React.useState('Known Incident Time');
	const handleChange = (event, newAlignment) => {
		setAlignment(newAlignment);
		if (event.target.value === 'left') {
			setMode('knownIncidentTime');
			setIncidentTimePickerLabel('Known Incident Time');
		} else if (event.target.value === 'right') {
			setMode('unknownIncidentTime');
			setIncidentTimePickerLabel('DVR Incident Time');
		}
	};
	const control = { value: alignment, onChange: handleChange, exclusive: true };

	return (
		<>
			<Navbar pageTitle="DVR Time Converter" />
			<Container maxWidth="md" sx={{ py: 4 }}>

				<Box sx={{ mb: 3 }}>
					<Typography variant="h5" sx={{ fontWeight: 800, color: '#0f172a', letterSpacing: '-0.4px' }}>
						DVR Time Converter
					</Typography>
					<Typography sx={{ color: '#64748b', mt: '6px', fontSize: '15px' }}>
						Convert incident time to DVR time when the DVR clock is not synced with the current time.
					</Typography>
				</Box>

				<Paper elevation={0} sx={{
					borderRadius: '14px',
					boxShadow: '0 1px 3px rgba(0,0,0,.07), 0 4px 16px rgba(0,0,0,.05)',
					p: '26px 26px 22px', mb: 2.5,
				}}>
					<ToggleButtonGroup size="large" {...control} aria-label="Mode" fullWidth sx={{ mb: 2.5 }}>
						<ToggleButton value="left" key="left">Known Incident Time</ToggleButton>
						<ToggleButton value="right" key="right">Unknown Incident Time</ToggleButton>
					</ToggleButtonGroup>

					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DemoContainer components={['DateTimePicker']}>
							<DateTimePicker label={incedentTimePickerLabel} onChange={incidentTimeChanged} />
						</DemoContainer>
					</LocalizationProvider>

					<Typography sx={{ color: '#64748b', fontSize: '14px', mt: 1.5, mb: 1.5 }}>
						Current Time: {currentTime}
					</Typography>

					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DemoContainer components={['DateTimePicker']}>
							<DateTimePicker label="Current DVR Time" onChange={dvrTimeChanged} />
						</DemoContainer>
					</LocalizationProvider>

					{(timeDiffString || dvrTimeConverted) && (
						<Box sx={{ mt: 2.5, p: '16px 20px', bgcolor: '#f5f3ff', borderRadius: '10px', border: '1px solid #ddd6fe' }}>
							{timeDiffString && (
								<Typography sx={{ fontSize: '14px', color: '#4c1d95', fontWeight: 600 }}>{timeDiffString}</Typography>
							)}
							{dvrTimeConverted && (
								<Typography sx={{ fontSize: '15px', color: '#1e293b', fontWeight: 700, mt: '6px' }}>{dvrTimeConverted}</Typography>
							)}
						</Box>
					)}

					<Button
						fullWidth variant="contained"
						onClick={convertTime}
						disabled={!buttonActive}
						sx={{
							mt: 2.5, p: '10px 20px', bgcolor: '#6d28d9',
							fontSize: '14px', fontWeight: 600, borderRadius: '8px',
							'&:hover': { bgcolor: '#5b21b6' },
							'&:disabled': { bgcolor: '#94a3b8' },
						}}
					>
						Convert Time
					</Button>
				</Paper>
			</Container>
		</>
	);
}

export default DVRTime;
